<template>
  <transition name="modal">
    <div class="modal-mask" @click.self="handleClose">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content rounded-8">
            
            <ModalHeader 
              title="Editar información"
              @close="handleClose"
            />
            
            <ModalBody>
              <EditStudentForm
                :student-data="formData"
                :errors="errors"
                :loading="loading"
                @update="handleFormUpdate"
              />
            </ModalBody>
            
            <ModalFooter>
              <button 
                type="button" 
                class="btn text-primary bg-utel-v2-secondary mx-3 rounded-8 sin-borde" 
                @click="handleClose"
                :disabled="loading"
              >
                Cancelar
              </button>
              
              <button 
                type="button" 
                class="btn text-white bg-utel rounded-8" 
                @click="handleSave"
                :disabled="loading || !isFormValid"
              >
                {{ loading ? 'Procesando...' : 'Guardar cambios' }}
              </button>
            </ModalFooter>
            
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ModalHeader from './components/ModalHeader.vue'
import ModalBody from './components/ModalBody.vue'
import ModalFooter from './components/ModalFooter.vue'
import EditStudentForm from './components/EditStudentForm.vue'

export default {
  name: 'ModalEditStudent',
  
  components: {
    ModalHeader,
    ModalBody,
    ModalFooter,
    EditStudentForm
  },

  props: {
    student: { type: Object, required: true },
    url: { type: String, required: true },
    from: { type: String, default: '' }
  },

  emits: ['close', 'success'],

  data() {
    return {
      formData: {
        firstname: '',
        lastname: '',
        email: '',
        cellphone: '',
        position: '',
        area: '',
        level: ''
      },
      errors: {},
      loading: false,
      validation: {
        firstname: { error: false, message: '' },
        lastname: { error: false, message: '' },
        email: { error: false, message: '' },
        cellphone: { error: false, message: '' }
      }
    }
  },

  computed: {
    apiUrl() {
      return `${this.url}/${this.student.id}`
    },

    isFormValid() {
      return this.formData.firstname?.trim().length > 0
    }
  },

  mounted() {
    this.initializeForm()
  },

  methods: {
    initializeForm() {
      this.formData = {
        firstname: this.student.firstname || '',
        lastname: this.student.lastname || '',
        email: this.student.email || '',
        cellphone: this.student.cellphone || '',
        position: this.student.position || '',
        area: this.student.area || '',
        level: this.student.level || ''
      }
    },

    handleFormUpdate(updatedData) {
      this.formData = { ...this.formData, ...updatedData }
      if (this.errors.firstname && updatedData.firstname) {
        delete this.errors.firstname
      }
    },

    async handleSave() {
      if (!this.isFormValid) return

      this.loading = true
      this.errors = {}

      try {
        await axios.put(this.apiUrl, this.formData)
        
        this.$emit('success')
        this.handleClose()

        setTimeout(async () => {
          const message = 'Colaborador actualizado exitosamente'
          
          await this.$swal({
            icon: 'success',
            title: '¡Éxito!',
            text: message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#1A0054',
            background: '#ffffff',
            color: '#1A0054'
          })
        }, 300)
        
        if (this.from === 'profile') {
          location.reload()
        }
      } catch (error) {
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        } else {
          console.error('Error updating student:', error)
        }
      } finally {
        this.loading = false
      }
    },

    handleClose() {
      if (!this.loading) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  width: 100%;
  max-width: 500px;
  margin: 0 20px;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from, .modal-leave-to {
  opacity: 0;
}
</style>